import Vue from "vue";
import App from "./App.vue";
import store from './store'
import router from "./router/index";
import {
  NavBar,
  Icon,
  Popup,
  Checkbox,
  CheckboxGroup,
  Button,
  Cell,
  CellGroup,
  Field,
  Toast,
  Dialog,
  ShareSheet,
  Loading,
  Swipe,
  SwipeItem,
  Lazyload,
  Popover,
  Tab,
  Tabs,
  List,
  DropdownMenu,
  DropdownItem,
  Sticky,
  Cascader,
  Search,
  Area,
  Switch,
  Form,
} from "vant";
import 'vant/lib/index.css'
import "./assets/styles/reset.css";
Vue.use(NavBar)
Vue.use(Icon)
Vue.use(Popup)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Button)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Field)
Vue.use(Toast)
Vue.use(Dialog)
Vue.use(ShareSheet)
Vue.use(Loading)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Lazyload)
Vue.use(Popover)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(List)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Sticky)
Vue.use(Cascader)
Vue.use(Search)
Vue.use(Area)
Vue.use(Switch)
Vue.use(Form)
Vue.config.productionTip = false;

new Vue({
  el: "#app",
  store,
  router,
  render: (h) => h(App),
});
